import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {Panel, FormLayout, RadioButtonGroup, PanelRadioButton} from 'shared/components';
import {FormattedMessage} from 'react-intl';

const NegativeBalancesForm = observer(({uiState}) => {
  const {typePolicy} = uiState;

  return (
    <Panel>
      <Panel.Header title={t('time_off.policy.edit.NEGATIVE_BALANCES')}/>
      <FormLayout>
        <div className='waterloo'>
          <FormattedMessage id='time_off.policy.edit.NEGATIVE_BALANCES_EXPLANATION'/>
        </div>
        <RadioButtonGroup
          className={'table'}
          name='preventNegativeBalance'
          selectedValue={typePolicy.preventNegativeBalance}
          onChange={(name, value) => typePolicy.merge({preventNegativeBalance: value})}
        >
          <PanelRadioButton
            value={false}
            label='time_off.policy.edit.Allow Negative Balances'
            description='time_off.policy.edit.ALLOW_NEGATIVE_BALANCES_EXPLANATION'
          />
          <PanelRadioButton
            value={true}
            label='time_off.policy.edit.Prevent Negative Balances'
            description='time_off.policy.edit.PREVENT_NEGATIVE_BALANCES_EXPLANATION'
          />
        </RadioButtonGroup>
      </FormLayout>
    </Panel>
  );
});

export default NegativeBalancesForm;
